module.exports = __webpack_public_path__ + "static/media/goldenprize-mackerel-brine.c26462db.png";